// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__oH8E8","inputWrap":"styles_inputWrap__3AqoE","input":"styles_input__2TjdZ"};